import axios from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { ExpenseWithSharesDto } from 'src/Services/API/generated';

export const useStopExpenseRecurrence = (
  options?: UseMutationOptions<ExpenseWithSharesDto, unknown, string>
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<ExpenseWithSharesDto, unknown, string>(
    ['stop-expense-recurrence', assetId],
    async (expenseId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await axios.delete<ExpenseWithSharesDto>(
        `${import.meta.env.VITE_API_URL}/assets/${assetId}/expenses/${expenseId}/recurrence`,
        { withCredentials: true }
      );
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['fetch-expenses', assetId]);
        queryClient.invalidateQueries(['fetch-expense', variables]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
